import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { ClientModel } from '../../models/client/client.model';

export class GetAttentionConsecutiveUseCase implements UseCase<{ IdAttention: string}, ClientModel> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(
        params: {IdAttention: string},
    ): Observable<ClientModel> {
        return this.ConsultRepository.getAttentionConsecutive(params);
    }
}
